import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Company Info */}
          <div className="space-y-4 lg:col-span-1">
            <Logo variant="full" size="md" className="brightness-0 invert" />
            <p className="text-sm text-gray-400">
              AI-powered novel writing, screenplay conversion, and professional publishing platform for authors.
            </p>
            <div className="flex gap-4">
              <a href="https://twitter.com/upost" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path></svg>
              </a>
              <a href="https://facebook.com/upost" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path></svg>
              </a>
              <a href="https://instagram.com/upost" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-400 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path></svg>
              </a>
            </div>
          </div>

          {/* AI Writing Tools */}
          <div>
            <h3 className="text-white font-semibold mb-4">AI Writing Tools</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/register" className="hover:text-purple-400 transition-colors">
                  Novel Writing Software
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-purple-400 transition-colors">
                  AI Story Generator
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-purple-400 transition-colors">
                  Character Development Tool
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-purple-400 transition-colors">
                  Plot Outline Creator
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-purple-400 transition-colors">
                  Dialogue Generator
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-purple-400 transition-colors">
                  Scene Writer
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-purple-400 transition-colors">
                  Multi-Revision AI
                </Link>
              </li>
            </ul>
          </div>

          {/* Professional Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Professional Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/screenplay-guide" className="hover:text-orange-400 transition-colors">
                  🎬 Screenplay Conversion
                </Link>
              </li>
              <li>
                <Link to="/screenplay-guide" className="hover:text-orange-400 transition-colors">
                  TV Series Pilot Writing
                </Link>
              </li>
              <li>
                <Link to="/amazon-publishing" className="hover:text-blue-400 transition-colors">
                  📚 Amazon KDP Publishing
                </Link>
              </li>
              <li>
                <Link to="/amazon-publishing" className="hover:text-blue-400 transition-colors">
                  Book Formatting Services
                </Link>
              </li>
              <li>
                <Link to="/copyright-protection" className="hover:text-red-400 transition-colors">
                  🛡️ Copyright Registration
                </Link>
              </li>
              <li>
                <Link to="/copyright-protection" className="hover:text-red-400 transition-colors">
                  WGA Script Registry
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-green-400 transition-colors">
                  💎 Craft AI Editing
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources & Guides */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources & Guides</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/blog" className="hover:text-purple-400 transition-colors font-semibold">
                  📚 Writing Blog
                </Link>
              </li>
              <li>
                <Link to="/press" className="hover:text-purple-400 transition-colors font-semibold">
                  📰 Press Releases
                </Link>
              </li>
              <li>
                <Link to="/screenplay-guide" className="hover:text-white transition-colors">
                  How to Sell to Netflix
                </Link>
              </li>
              <li>
                <Link to="/screenplay-guide" className="hover:text-white transition-colors">
                  Hollywood Screenplay Format
                </Link>
              </li>
              <li>
                <Link to="/amazon-publishing" className="hover:text-white transition-colors">
                  Amazon Bestseller Guide
                </Link>
              </li>
              <li>
                <Link to="/amazon-publishing" className="hover:text-white transition-colors">
                  Self-Publishing Tips
                </Link>
              </li>
              <li>
                <Link to="/copyright-protection" className="hover:text-white transition-colors">
                  Copyright Protection 101
                </Link>
              </li>
              <li>
                <Link to="/nyt-bestseller-guide" className="hover:text-white transition-colors">
                  NYT Bestseller Strategy
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-white transition-colors">
                  Writing Pricing Plans
                </Link>
              </li>
              <li>
                <Link to="/affiliates" className="hover:text-white transition-colors">
                  💰 Affiliate Program
                </Link>
              </li>
            </ul>
          </div>

          {/* Company & Account */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About UPost
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-purple-400 transition-colors font-semibold">
                  📝 Blog & Articles
                </Link>
              </li>
              <li>
                <Link to="/press" className="hover:text-purple-400 transition-colors font-semibold">
                  📰 Press Releases
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact Support
                </Link>
              </li>
              <li>
                <Link to="/referrals" className="hover:text-white transition-colors">
                  Referral Program
                </Link>
              </li>
            </ul>
            
            <h3 className="text-white font-semibold mb-4 mt-6">Account</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/login" className="hover:text-white transition-colors">
                  Sign In
                </Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-white transition-colors">
                  Create Account
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="hover:text-white transition-colors">
                  My Dashboard
                </Link>
              </li>
              <li>
                <Link to="/settings" className="hover:text-white transition-colors">
                  Account Settings
                </Link>
              </li>
              <li>
                <Link to="/admin" className="hover:text-white transition-colors">
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* SEO Keywords Section */}
        <div className="border-t border-gray-800 pt-6 pb-6">
          <div className="text-xs text-gray-500 text-center max-w-5xl mx-auto leading-relaxed">
            <p className="mb-2">
              <strong className="text-gray-400">Popular Searches:</strong> AI novel writing software, screenplay converter, novel to screenplay, Amazon KDP publishing, copyright registration online, WGA script registry, AI book writing, manuscript editor, professional writing software, screenwriter tools, self-publishing platform, AI story generator, character development software, plot outline tool, Hollywood screenplay format, Netflix pitch guide, book formatting services, author platform, creative writing AI, fiction writing tools
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center mb-4">
            <p className="text-sm text-gray-500 mb-4 md:mb-0">
              © {new Date().getFullYear()} UPost. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/terms" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/cookies" className="hover:text-white transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
          
          {/* Disclaimer */}
          <div className="text-center py-4 border-t border-gray-800">
            {/* Web-Tech Services Badge */}
            <div className="mb-4">
              <a 
                href="https://web-techservices.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-purple-900 hover:bg-purple-800 px-4 py-2 rounded-full transition-colors"
              >
                <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="text-white font-medium">A Product of Web-Tech Services</span>
                <span className="text-green-400 text-sm">✓ Verified Business</span>
              </a>
            </div>
            
            <div className="bg-gray-800 rounded-lg p-4 max-w-4xl mx-auto mb-4">
              <p className="text-xs text-gray-400 leading-relaxed">
                <strong className="text-gray-300">DISCLAIMER:</strong> UPost is an AI-powered writing platform owned and operated by <strong className="text-gray-300">Web-Tech Services</strong> (Google Verified Business, Arlington, TX). We are NOT affiliated with, endorsed by, or sponsored by Amazon, Netflix, Apple, Google, or any other third-party services mentioned on this website. Our educational content is for informational purposes only. We do not guarantee publication, sales, or acceptance by any platform. All trademarks are property of their respective owners.
              </p>
            </div>
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} Web-Tech Services. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
